import { GlobalEvents } from 'modules/global';
import { CookiesEvents } from 'modules/cookies';
import { FETCH_LANDINGS } from 'modules/landings-info';
import { FETCH_MODEL } from 'modules/model-json';
import { FETCH_SERVICE_CATEGORIES } from 'modules/service-categories';
import { createStore } from 'store';
import { State, Store } from 'store/types';

export const initWidgetData = (state: State): Store => {
  const store = createStore();

  store.dispatch(GlobalEvents.setRequestParams, {
    orchestratorHost: state.orchestratorHost,
    useCredentials: state.useCredentials,
    apiKey: state.apiKey,
    requestID: state.requestID,
  });
  store.dispatch(GlobalEvents.setIsBot, state.isBot);
  store.dispatch(GlobalEvents.setUserAgent, state.userAgent);
  store.dispatch(CookiesEvents.set, document.cookie);
  store.dispatch(FETCH_MODEL.setModelState, state.modelJson);

  store.dispatch(FETCH_LANDINGS.success, state.landings?.landingsList ?? undefined);
  store.dispatch(
    FETCH_SERVICE_CATEGORIES.success,
    state.serviceCategories?.serviceCategoriesList ?? undefined
  );

  return store;
};
